var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_728",
    "data-name": "Group 728",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.666,
    height: 22.666,
    viewBox: "0 0 22.666 22.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M22.389,21.057l-6.446-6.446a8.989,8.989,0,1,0-1.335,1.335l6.446,6.446a.944.944,0,1,0,1.335-1.335Zm-13.417-5a7.083,7.083,0,1,1,7.083-7.083A7.09,7.09,0,0,1,8.972,16.058Z",
    transform: "translate(0 -0.003)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownSearch);
export default __webpack_public_path__ + "static/media/dropdown-search.82044421bcd662c1c1cdd4fdacfa6ff2.svg";
export { ForwardRef as ReactComponent };